import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import React from 'react';
import '../../icons/abstract/AbstractArcIcon.js';
import '../../icons/AddCircleIcon.js';
import '../../icons/AddCircleOutlineIcon.js';
import '../../icons/ArrowCircleRightIcon.js';
import { ArrowLeftIcon } from '../../icons/ArrowLeftIcon.js';
import '../../icons/ArrowRightIcon.js';
import '../../icons/BoltIcon.js';
import '../../icons/BookmarkStarIcon.js';
import '../../icons/CalendarIcon.js';
import '../../icons/CancelIcon.js';
import '../../icons/ChatIcon.js';
import '../../icons/CheckCircleIcon.js';
import '../../icons/ChevronDownIcon.js';
import '../../icons/ChevronLeftIcon.js';
import '../../icons/ChevronRightIcon.js';
import '../../icons/ChevronUpIcon.js';
import '../../icons/CloseIcon.js';
import '../../icons/MenuIcon.js';
import '../../icons/NotificationActiveIcon.js';
import '../../icons/PaperPlaneIcon.js';
import '../../icons/PendingIcon.js';
import '../../icons/PersonIcon.js';
import '../../icons/PlayCircleIcon.js';
import '../../icons/RemoveCircleIcon.js';
import '../../icons/SearchIcon.js';
import '../../icons/SellIcon.js';
import '../../icons/ShoppingBagIcon.js';
import '../../icons/SmartphoneIcon.js';
import '../../icons/StarIcon.js';
import '../../icons/StarOutlineIcon.js';
import '../../icons/SuccessCheckCircleIcon.js';
import '../../icons/TuneIcon.js';
import '../../icons/FourPointStarIcon.js';

var StyledIconButton = styled(IconButton)({
    '& .MuiTouchRipple-child': {
        backgroundColor: "#f6f8fa !important",
    },
});
var BackButton = function (_a) {
    var _b = _a.iconSize, iconSize = _b === void 0 ? 20 : _b, props = __rest(_a, ["iconSize"]);
    return (React.createElement(StyledIconButton, __assign({ "aria-label": "back", color: "primary", sx: {
            width: iconSize * 2,
            height: iconSize * 2,
        } }, props),
        React.createElement(ArrowLeftIcon, { sx: {
                fontSize: iconSize,
            } })));
};

export { BackButton };
//# sourceMappingURL=BackButton.js.map
